<template>
  <aside class="v-aside">
    <slot />
  </aside>
</template>

<style>
.v-aside {
  overflow: auto;
  flex-shrink: 0;
}
</style>
